import Store from 'store'
import axios from '../../axios'
import {
  IGetRoomInfo,
  IReportViewDuration,
  IUploadReplayViewDetail,
} from './interface'
import { getAppData } from '@utils'
import { hex_sha1 } from '@utils/lib'
import apiService from '../../apiService'
import UserStore from '@stores/UserStore'
import { addZhiniaoPrefix } from '@utils/SSOHelper'

export default {
  /**
   * desc：获取url参数，并进一步获取页面所需的参数
   * 1.初始化Web IM SDK 登录参数
   * 2.获取页面渲染数据，包括用户id、昵称，直播名称，直播状态，视频地址等数据
   * 3.获取视频播放地址
   * method: get
   */
  queryLiveRoomDetailById: (params: any) => {
    const {
      fromType,
      roomId,
      province,
      provinceCN,
      city,
      cityCN,
      district,
      districtCN,
      fullPath,
      fullPathCN,
    } = params
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/privation/queryLiveRoomDetailById.do'), {
      params: {
        dataType: '1',
        roomId,
        isSupportAudioLive: 1,
        /** 是否支持互动直播 */
        supportInteractive: 1,
        deviceType: 1,
        channel: 'web',
        ver: '8.1.6',
        /** 是否过滤可见性 ''过滤 */
        fromType,
        /** 地理位置相关信息 */
        province,
        provinceCN,
        city,
        cityCN,
        district,
        districtCN,
        fullPath,
        // 编码--有些组织带特俗符号-比如xxx[员工]
        fullPathCN: encodeURIComponent(JSON.stringify(fullPathCN)),
      },
    })
  },
  getLiveRoomInfo: (roomId: string) => {
    return axios.post(addZhiniaoPrefix('/learn/app/clientapi/live/secret/getLiveRoomInfo.do'), {
      roomId,
    })
  },
  /**
   * desc：获取回放数据
   * method: get
   */
  queryLiveRoomPlaybDataByRoomId: (
    roomId: string,
    fromType: any,
    accessToken?: string,
    inMladmin?: boolean
  ) => {
    return axios.get(
      addZhiniaoPrefix(`/learn/app/clientapi/live/${inMladmin ? '' : 'privation/'}queryLiveRoomPlaybDataByRoomId.do`),
      {
        params: {
          roomId,
          fromType,
          accessToken, // 用于中台的人社监督回放预览，免登免校验可见性，在中台获取accessToken后拼接到url传递过来
        },
      }
    )
  },
  /**
   * desc：获取Token
   * method: get
   */
  getToken: (data: IGetRoomInfo) => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/getToken.do'), {
      params: {
        roomId: data.roomId,
        channel: 'web',
        ver: '3.7.4',
        appId: 'com.mlearning.guangqichuanqi',
        userName: data.sid,
      },
    })
  },
  /**
   * desc：获取Token
   * method: psot
   */
  entryLiveRoom: (token: string, roomId: string) => {
    const nonce = 10 + parseInt((Math.random() * 90).toString(), 10)
    const timestamp = parseInt((new Date().getTime() / 1000).toString(), 10)
    const appData = getAppData()
    const sign = hex_sha1(appData.paAppKey + nonce + timestamp)
    return axios.post(
      addZhiniaoPrefix(`${appData.paServerUrl}live/sdk/entryLiveRoom.do`),
      {
        liveId: roomId,
        type: 2,
        clearHeaderMap: true,
      },
      {
        headers: {
          appId: appData.paAppId,
          token,
          imei: '',
          nonce,
          timestamp,
          sign,
          device: 4,
          version: '2',
        },
      }
    )
  },
  /**
   * desc: 获取用户标记
   * 用于腾讯im登陆
   * method ：get
   */
  getUserSig: (roomId: string, userId: string) => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/getUserSig.do'), {
      params: {
        userId,
        roomId,
        channel: 'web',
        ver: '3.7.4',
        appId: 'com.mlearning.guangqichuanqi',
      },
    })
  },
  /**
   * 判断当前用户的企业是否开启了人社增值服务
   */
  getIsOpenHumanSocietyVas: () => {
    return axios.get('/learn/app/clientapi/user/isOpenHumanSocietyVas.do', {})
  },
  /**
   * desc: 已挂靠人社资源调用接口判断是否可学
   * method ：get
   */
  getResourceRule: (
    resourceId: string,
    resourceType: number,
    trainingItemId?: string
  ) => {
    return axios.get(
      '/learn/app/clientapi/trainingclass/training/item/selectResourceRule.do',
      {
        params: {
          resourceId,
          resourceType,
          trainingItemId,
        },
      }
    )
  },
  /**
   * desc: 上报直播观看时长
   * 上报观看时长
   * method ：get
   */
  reportViewDuration: (params: IReportViewDuration) => {
    return axios.post(
      addZhiniaoPrefix('/learn/app/clientapi/live/viewer/reportViewDuration.do'),
      {
        ...params,
      }
    )
  },
  /**
   * desc: 多人上报直播/回放观看时长
   * 多人·上报观看时长
   * method ：get
   */
  reportMultipleViewDuration: (params: any) => {
    return axios.post(
      addZhiniaoPrefix('/learn/app/clientapi/live/signin/zmh/reportViewDuration.do'),
      {
        ...params,
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          sid: UserStore.getSid(),
        },
      }
    )
  },
  /**
   * desc: 多人观看用户直播/回放信息上报
   * method ：get
   */
  reportMultipleUserInfo: (params: any) => {
    return axios.post(
      addZhiniaoPrefix('/learn/app/clientapi/live/signin/zmh/reportUserInfo.do'),
      {
        ...params,
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          sid: UserStore.getSid(),
        },
      }
    )
  },
  /**
   * desc: 寿险白名单
   * method ：get
   */
  reportCheckPermission: (type: any) => {
    return axios.get(
      addZhiniaoPrefix('/learn/app/clientapi/live/permission/checkPermission.do'),
      {
        params: {
          type: 10,
        },
      }
    )
  },

  /**
   * desc: 上报回放观看时长
   * 上报观看时长
   * method ：get
   */
  uploadReplayViewDetail: (params: IUploadReplayViewDetail) => {
    return axios.post(addZhiniaoPrefix('/learn/app/clientapi/live/uploadReplayViewDetail.do'), params)
  },
  getNoticeByRoomId: (roomId: string) => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/bank/getInfoByRoomId.do'), {
      params: {
        roomId,
      },
    })
  },
  checkSecretRole: (roomId: string, secretValue: string) => {
    return apiService.post(
      addZhiniaoPrefix('/learn/app/clientapi/live/secret/checkSecretRole.do'),
      {
        roomId,
        secretValue,
        sid: (Store.get('liveUserInfo') || {}).sid,
      },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
      }
    )
  },
  // 获取连麦主播、回放中主播信息（不校验权限）
  getAnchorDetail(roomId: string, userId: string) {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/liveAnchorInfo.do'), {
      params: {
        roomId,
        userId,
      },
    })
  },

  // 判断所属组织
  getLiveOrgId(roomId: string) {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/third/zmh/checkRoomOrgId.do'), {
      params: {
        roomId,
      },
    })
  },

  // 获取课件详情
  getFileDetail(fileId: string) {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/webfile/fileDetail.do'), {
      params: {
        fileId,
      },
    })
  },
  // 获取课件列表
  getFileList(params: {roomId: string, pageNo: number, pageSize: number}) {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/webfile/getReplyWebFile.do'), {
      params: {
        ...params,
      },
    })
  },
  queryDetailForViewer(params) {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/room/queryDetailForViewer.do'), {
      params
    })
  },
  /** 课件观看时长上报 */
  reportCoursewareViewDuration(params){
    return apiService.post(addZhiniaoPrefix('/learn/app/clientapi/live/webfile/report/view.do'), params, {},{params}) // 后台要求，post请求，数据放url上
  },
  // 获取举手列表
  getRaisehandList: (data: any) => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/viewer/playingList.do'), {
      params: {
        ...data,
        nonGzip: 1,
      }
    }) as any
  },
  /** 获取敏感词 */
  getSensitiveWord: () => {
    return axios.get(addZhiniaoPrefix('/znlive/resource/words.json'), {
      params: { nonGzip: 1 }
    })
  },
  // 切换七牛后新的拉流接口
  getStreamQiNiu: (params) => {
    return axios.post(addZhiniaoPrefix('/learn/app/clientapi/live/qiNiu/stream/roomInfo.do'),
      {
        ...params,
      }
    )
  },
  /** 迎宾配置 */
  getJoinInfo(params) {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/join.do'), {
      params: {
        ...params
      }
    })
  },
}
